import React from 'react';
import { useSyncStatus } from '../contexts/SyncStatusContext';

const SyncStatusBar = () => {
  const { syncStatus } = useSyncStatus();

  if (!syncStatus.isSyncing && !syncStatus.message) {
    return null;
  }

  const progressPercentage = syncStatus.total > 0
    ? (syncStatus.progress / syncStatus.total) * 100
    : 0;

  return (
    <div style={{
      position: 'fixed',
      top: '60px',
      left: 0,
      right: 0,
      backgroundColor: syncStatus.isSyncing ? '#14b8a6' : syncStatus.message.includes('failed') || syncStatus.message.includes('error') ? '#ef4444' : '#10b981',
      color: 'white',
      padding: '12px 20px',
      zIndex: 9998,
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      transition: 'all 0.3s ease'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        gap: '15px'
      }}>
        {syncStatus.isSyncing && (
          <div style={{
            width: '20px',
            height: '20px',
            border: '3px solid rgba(255, 255, 255, 0.3)',
            borderTop: '3px solid white',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
        )}

        <div style={{ flex: 1 }}>
          <div style={{
            fontSize: '14px',
            fontWeight: '600',
            marginBottom: syncStatus.total > 0 ? '6px' : '0'
          }}>
            {syncStatus.message}
            {syncStatus.total > 0 && (
              <span style={{ marginLeft: '10px', fontSize: '13px', opacity: 0.9 }}>
                ({syncStatus.progress}/{syncStatus.total})
              </span>
            )}
          </div>

          {syncStatus.total > 0 && (
            <div style={{
              width: '100%',
              height: '6px',
              backgroundColor: 'rgba(255, 255, 255, 0.3)',
              borderRadius: '3px',
              overflow: 'hidden'
            }}>
              <div style={{
                width: `${progressPercentage}%`,
                height: '100%',
                backgroundColor: 'white',
                transition: 'width 0.3s ease',
                borderRadius: '3px'
              }} />
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default SyncStatusBar;
